import { ApolloClient, gql } from '@apollo/client/core';
import * as VPConfig from '../api/VPConfig';
import { Query } from '../generated/graphql';

const GET_CONFIG_QUERY = gql`
  query GetConfig {
    vpConfig {
      cognito {
        region
        clientId
      }
    }
  }
`;

export const getConfig = async (client: ApolloClient<Query>): Promise<VPConfig.VPConfig> => {
  const { data } = await client.query({
    query: GET_CONFIG_QUERY,
    fetchPolicy: 'network-only',
  });

  return VPConfig.fromGql(data.vpConfig);
};
